import React from 'react'
import { Modal, Button } from 'web/src/app/root/components/common'
import { useSelector } from 'react-redux'
import { Box } from '@material-ui/core'
import { Typography } from '@material-ui/core'
import { resetDeviceBaitThreshold } from '../api/device-api'

export const DeviceConfirmThresholdResetModal = ({
    open,
    setOpen,
    onConfirmClick,
    deviceId
}) => {
    const { locale } = useSelector(state => state.main)

    const onConfirm = async () => {
        try {
            await resetDeviceBaitThreshold(deviceId)
            onConfirmClick()
            setOpen(false)
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Modal open={open} setOpen={setOpen}>
            <Typography>
                {locale.devices.areYouSureYouWantToResetTheActivityThreshold}
            </Typography>
            <Box
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: 40,
                    gap: 20
                }}
            >
                <Button onClick={onConfirm}>{locale.common.confirm}</Button>
                <Button reverted onClick={() => setOpen(false)}>
                    {locale.common.cancel}
                </Button>
            </Box>
        </Modal>
    )
}
